var map = {
	"./arbeitnehmer.jpg": "fe1d",
	"./arrow.png": "5a52",
	"./barchart.png": "59c5",
	"./check.png": "bc05",
	"./compliance.jpg": "7e87",
	"./cover-sustain.jpg": "3543",
	"./cover.jpg": "f97d",
	"./footer.jpg": "ec6f",
	"./hr.png": "c49e",
	"./kreislauf.svg": "a11a",
	"./menschenrechte.jpg": "b56a",
	"./report-teaser.jpg": "9726",
	"./solar.jpg": "5319",
	"./soziales.jpg": "7f0b",
	"./stats.jpg": "bb04",
	"./tile.jpg": "9d01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1f9e";